<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <div class="connect-market-page">
      <owner-connect-header />
      <div class="container">
        <page-loading :show="loading" />
        <div class="search--container search--listing-container">
          <button-switch-owner-connect />
          <div class="connect-market-layout">
            <div class="left--col">
              <project-connect-content
                :projects="projects"
                :meta="meta"
                :loading="loading"
                :locked="locked"
                :error="error"
                :action-loading-id="actionLoadingId"
                empty-text="Belum ada project yang tersedia untuk Project Connect."
                @show-contact="showContact"
                @change-page="changePage"
              />
            </div>
            <div class="right--col connect-filter-panel" :class="{ active: isActive }">
              <search-filters />
            </div>
          </div>
        </div>
      </div>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import OwnerConnectHeader from '@/components/search-listing/owner-connect-header.vue';
import ButtonSwitchOwnerConnect from '@/components/search-listing/button-switch-owner-connect.vue';
import ProjectConnectContent from '@/components/project-connect/project-connect-content.vue';
import SearchFilters from '@/components/search-listing/filters.vue';
import PageLoading from '@/components/content-loading/page-loading.vue';
import { mapState } from 'vuex';

export default {
  name: 'project-connect',
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    OwnerConnectHeader,
    ButtonSwitchOwnerConnect,
    ProjectConnectContent,
    SearchFilters,
    PageLoading,
  },
  computed: {
    ...mapState({
      projects: (state) => state.projectConnect.projects,
      meta: (state) => state.projectConnect.projectsMeta,
      loading: (state) => state.projectConnect.loading,
      locked: (state) => state.projectConnect.locked,
      error: (state) => state.projectConnect.error,
      actionLoadingId: (state) => state.projectConnect.actionLoadingId,
      isActive: (state) => state.searchListing.activeFilterSidebar,
    }),
    breadcrumbs() {
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: 'Project Connect',
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  methods: {
    async getProjects(page) {
      await this.$store.dispatch('searchListing/loadRouteQuery', {
        query: this.$route.query,
        params: this.$route.params,
      });
      await this.$store.dispatch('projectConnect/getProjects', page || this.$route.query.page);
    },
    async changePage(page) {
      await this.getProjects(page);
    },
    async showContact(project) {
      try {
        await this.$store.dispatch('projectConnect/showContact', project.id);
        const result = await this.$swal({
          type: 'success',
          title: 'Berhasil Masuk Favorit Saya',
          text: 'Project berhasil dimasukkan ke Favorit Saya. Pergi ke halaman favorit saya untuk melihat kontak PIC project',
          showCancelButton: true,
          confirmButtonText: 'Ke Favorit Saya',
          cancelButtonText: 'Tutup',
          reverseButtons: true,
        });

        if (result.value) {
          await this.$router.push({ name: 'shortlist-project-connect' });
        }
      } catch (error) {
        const payload = error.response && error.response.data ? error.response.data : null;
        const message =
          payload && (payload.errors || payload.error || payload.message)
            ? payload.errors || payload.error || payload.message
            : error.message
            ? error.message
            : 'Maaf terjadi kesalahan, silakan coba lagi nanti.';
        await this.$swal('Oops...', message, 'error');
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('projectConnect/restoreInitialState');
    await this.$store.dispatch('masters/getPropertyTypes');
    await this.getProjects();
  },
  watch: {
    '$route.query': {
      deep: true,
      async handler() {
        await this.getProjects();
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.connect-market-page {
  min-height: 100vh;
  padding-bottom: 56px;
  background: #fafafa;
}

.connect-market-panel {
  position: relative;
  padding: 18px;
  border: 1px solid #eeeeee;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
  overflow: hidden;

  > * {
    position: relative;
    z-index: 1;
  }
}

.connect-market-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 332px;
  gap: 22px;
  align-items: start;

  .left--col {
    width: 100%;
    min-width: 0;
    margin-right: 0;
  }

  .right--col {
    width: 100%;
  }
}

.connect-filter-panel {
  position: sticky;
  top: 120px;
  border-radius: 16px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 12px 30px rgba(33, 33, 33, 0.05);
}

@media #{$tablets} {
  .connect-market-layout {
    grid-template-columns: minmax(0, 1fr) 286px;
    gap: 16px;
  }

  .connect-filter-panel {
    top: 96px;
    border-radius: 14px;
  }
}

@media #{$phones} {
  .connect-market-layout {
    display: block;
  }

  .connect-filter-panel {
    position: fixed;
    top: 0;
    left: 100%;
    right: auto;
    bottom: auto;
    z-index: 2200;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    box-shadow: -18px 0 36px rgba(0, 0, 0, 0.12);
    overflow-y: auto;
    transition: left 0.28s ease;

    &.active {
      left: 0;
    }
  }

  .connect-market-panel {
    padding: 12px;
    border-radius: 18px;
  }
}
</style>
